import { AdminProjectPlan } from '@platform/client/schemas';
import {
  ProfileSection,
  ProfileItem,
  ProfileItemLong,
  ProfileItemStrList,
} from './ProfileComponents';
import { formatDateStr } from '../../dashboard/my-projects/utils';

export const ProjectPlanSection = ({ planData }: { planData: AdminProjectPlan }) => {
  return (
    <div>
      <ProfileSection title='Project Plan - Org Before Call' columns={1}>
        <ProfileItem label='Primary Outcome' value={planData.organizationBrief?.primaryOutcome} />
        <ProfileItemLong label='Objective' value={planData.organizationBrief?.objective} />
        <ProfileItem label='Steps taken' value={planData.organizationBrief?.stepsTaken} />
        <ProfileItem label='Constraints' value={planData.organizationBrief?.constraints} />
        <ProfileItem label='Impact' value={planData.organizationBrief?.impact} />
        <ProfileItem label='Questions for pro(s)' value={planData.organizationBrief?.questions} />
        <ProfileItem
          label='Last saved'
          value={
            planData.organizationBrief?.updatedAt ?
              formatDateStr(planData.organizationBrief.updatedAt)
            : 'Not submitted'
          }
        />
      </ProfileSection>
      <ProfileSection title='Project Plan - Pro Before Call' columns={1}>
        <ProfileItemStrList
          label='Skills'
          value={planData.skills?.map(
            (s) =>
              `[${s.userFirstname}] - ${s.skillsAlignment ? s.skillsAlignment : 'Not provided'}`,
          )}
        />
        <ProfileItem label='Questions for org' value={planData.professionalBrief?.questions} />
        <ProfileItem
          label='Last saved'
          value={
            planData.professionalBrief?.updatedAt ?
              formatDateStr(planData.professionalBrief.updatedAt)
            : 'Not submitted'
          }
        />
      </ProfileSection>
      <ProfileSection title='Project Plan - Completed on Call' columns={1}>
        <ProfileItemStrList
          label='Deliverables'
          value={planData.deliverables?.map((d) => d.deliverable)}
        />
        <ProfileItem label='Next steps' value={planData.nextSteps} />
        <ProfileItem label='Communication' value={planData.communicationNotes} />
        <ProfileItem label='Availability' value={planData.availabilityNotes} />
        {planData.tasks && planData.tasks.length > 0 && (
          <ProfileItemStrList
            label='Tasks'
            value={planData.tasks.map((t) => `[${t.userFirstname}] - ${t.task}`)}
          />
        )}
        <ProfileItem
          label='Last saved'
          value={planData.updatedAt ? formatDateStr(planData.updatedAt) : 'Not submitted'}
        />
      </ProfileSection>
    </div>
  );
};
